// H5 identity module routes.
import type { RouteRecordRaw } from "vue-router";

export const identityRoutes: RouteRecordRaw[] = [
  {
    path: "/login",
    name: "login",
    component: () => import("@/modules/identity/pages/SignInPage.vue"),
    meta: { public: true },
  },
  {
    path: "/register",
    name: "register",
    component: () => import("@/modules/identity/pages/RegisterPage.vue"),
    meta: { public: true },
  },
  {
    path: "/mine",
    name: "mine",
    component: () => import("@/modules/identity/pages/MinePage.vue"),
  },
  {
    path: "/settings/password",
    name: "password",
    component: () => import("@/modules/identity/pages/ChangePasswordPage.vue"),
  },
  {
    path: "/settings/payment-pin",
    name: "payment-pin",
    component: () => import("@/modules/identity/pages/PaymentPinPage.vue"),
  },
];
